<template>
  <div>
    <!-- 拜访次数统计 -->
    <div class="visit-stat-section" v-loading="loading">
      <div class="section-title">拜访次数统计</div>
      <div class="visit-filter">
        <el-date-picker
          v-model="searchInfo.visitTimeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          class="visit-select"
          :picker-options="visitPickerOptions"
          value-format="yyyy-MM-dd"
          @change="changeVisitTimeRangeHandle"
        />
        <el-input
          style="width: 200px;"
          v-model="searchInfo.visitDoctorName"
          placeholder="请输入医生姓名"
          size="small"
          suffix-icon="el-icon-search"
          @input="inputVisitDoctorNameHandle"
        />
      </div>
      <CustomTable
        :tableData="tableData"
        :column="visitColumns"
        border
        class="visit-table"
        :header-cell-style="headerCellStyle"
        max-height="350"
      >
        <template slot="nameCell" slot-scope="{ row }">
          <el-tag
            type="info"
            effect="plain"
            size="small"
            @click="$emit('nameClick', row)"
          >{{ row.doctorName }}</el-tag>
        </template>
        <template slot="starCell" slot-scope="{ row }">
          <CustomStarText :saleStar="row.saleStar" :avgStar="row.avgStar" />
        </template>
        <template slot="followerTag" slot-scope="{ row }">
          <span class="visit-detail-link" @click="showOrHideModalHandle('showVisitDetail', row)">查看拜访详情</span>
        </template>
      </CustomTable>
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageNum"
          @current-change="changePageHandle"
        ></el-pagination>
      </div>
    </div>

    <!-- 拜访记录详情弹窗 -->
    <CustomModal
      v-model="modalInfo.showVisitDetail"
      title="拜访记录"
      width="800px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showVisitDetail')"
    >
      <VisitDetail
        v-if="modalInfo.showVisitDetail"
        :searchDateRange="searchInfo.visitTimeRange || []"
        :currentClueInfo="currentClueInfo"
        @nameClick="$emit('nameClick', $event)"
      />
    </CustomModal>
  </div>
</template>

<script>
import { debounce } from '@/utils/validateBase'
import request from '@/utils/request'
export default {
  name: 'VisitNumInfo',
  props: {
    showFollowerCol: {
      type: Boolean,
      default: true
    },
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        total: 60,
        pageSize: 10,
        pageNum: 1
      },
      searchInfo: {
        visitDoctorName: '',
        visitTimeRange: ''
      },
      // 日期选择器快捷选项
      visitPickerOptions: {
        shortcuts: [
          {
            text: '近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      modalInfo: {
        showVisitDetail: false
      },
      currentClueInfo: {}
    }
  },
  computed: {
    visitColumns() {
      const columns = [
        { prop: 'doctorName', label: '医生', minWidth: '100', align: 'left', slotName: 'nameCell' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell' },
        { prop: 'siteVisitCount', label: '坐诊点拜访次数', minWidth: '120', align: 'center' },
        { prop: 'homeVisitCount', label: '家访拜访次数', minWidth: '120', align: 'center' },
        { prop: 'banquetVisitCount', label: '宴请拜访次数', minWidth: '120', align: 'center' },
        { prop: 'followVisitCount', label: '跟诊拜访次数', minWidth: '120', align: 'center' },
        { prop: 'wechatVisitCount', label: '微信拜访次数', minWidth: '120', align: 'center' },
        { prop: 'phoneVisitCount', label: '电话拜访次数', minWidth: '120', align: 'center' },
        { prop: 'workName', label: '跟进人', minWidth: '100', align: 'left' },
        { prop: 'follower', label: '操作', minWidth: '100', align: 'left', slotName: 'followerTag' }
      ]
      return this.showFollowerCol ? columns : columns.filter(col => col.prop !== 'workName')
    }
  },
  methods: {
    async getTableData() {
      const visitTimeRange = this.searchInfo.visitTimeRange || []
      const params = {
        doctorName: this.searchInfo.visitDoctorName || '',
        startTime: visitTimeRange[0] ? (visitTimeRange[0] + ' 00:00:00') : '',
        endTime: visitTimeRange[1] ? (visitTimeRange[1] + ' 23:59:59') : '',
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        }
      }
      try {
        this.loading = true
        const res = await request.get('/cluepool/pc/visit/queryVisitStatistics', params, '')
        if (res.code === 200) {
          this.tableData = res.data.data || []
          this.pageInfo.total = res.data.totalElements || 0
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.error('获取拜访次数统计数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    headerCellStyle() {
      return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
    },
    showOrHideModalHandle(modalName, itemInfo) {
      this.modalInfo[modalName] = !this.modalInfo[modalName]
      if (itemInfo) {
        this.currentClueInfo = itemInfo
      }
    },
    changeVisitTimeRangeHandle() {
      this.getTableData()
    },
    inputVisitDoctorNameHandle: debounce(function () {
      this.getTableData()
    }, 300),
    changePageHandle(page) {
      this.pageInfo.pageNum = page
      this.getTableData()
    }
  },
  mounted() {
    this.getTableData()
  },
  components: {
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue'),
    CustomTable: () => import('@/components/CustomTable.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    VisitDetail: () => import('./modal/VisitDetail.vue')
  }
}
</script>

<style scoped lang="less">
.visit-stat-section {
  background: #fff;
  border-radius: 4px;
  padding: 20px 24px;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1F2329;
    margin-bottom: 16px;
  }

  .visit-filter {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .visit-select {
      width: 260px;

      /deep/ .el-input__inner {
        font-size: 13px;
      }
    }
  }

  .visit-table {
    /deep/ .el-table {
      font-size: 13px;
      color: #1F2329;
      border-color: #EBEAEE;

      &::before,
      &::after {
        background-color: #EBEAEE;
      }

      th {
        padding: 0 !important;
        height: 40px;
      }

      td {
        padding: 0 !important;
        height: 44px;
      }

      .cell {
        line-height: 20px;
      }
    }

    /deep/ .el-tag--plain.el-tag--info {
      background-color: #F7F8F9;
      border-color: #EBEAEE;
      color: #667182;
      height: 24px;
      line-height: 22px;
      padding: 0 10px;
      border-radius: 12px;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        border-color: #1890FF;
        color: #1890FF;
      }
    }

    .visit-detail-link {
      color: #1890FF;
      text-decoration: none;
      cursor: pointer;
    }
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
